const getWebsiteFlowsGuid = state => state.automationTab.websiteFlows.guid;
export default getWebsiteFlowsGuid;